//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import ContentSourceType from '@models/ContentSourceType';

export enum StreamSourceTypes {
  HASHTAG = 'hashtag',
  USER = 'user',
  MENTIONS_AND_TAGS = 'mentions_and_tags',
  UGC = 'ugc',
  TEAM_MEDIA = 'teamMedia',
}

export const StreamSourceTypeLabels = {
  [StreamSourceTypes.HASHTAG]: 'Hashtag',
  [StreamSourceTypes.USER]: 'User',
  [StreamSourceTypes.MENTIONS_AND_TAGS]: 'Mentions & Tags',
} as const;

export enum StreamSourcePillType {
  ADDED_SOURCE = 'addedSource',
  EXCLUDED_SOURCE = 'excludedSource',
  EMPTY_SOURCE = 'emptySource',
}

export enum StreamExcludedContentSourceTypes {
  HASHTAG = 'Hashtag',
  USERNAME = 'Username',
}

export const DEFAULT_STREAM_NAME = 'Default';

export const INSTAGRAM_STREAM_SOURCE_NETWORK = 'instagram';
export const TIKTOK_STREAM_SOURCE_NETWORK = 'tiktok';

export const GRAPH_API_LEARN_MORE_LINK =
  'https://support.bazaarvoice.com/s/article/Configuring-your-Facebook-and-Instagram-Account';

// TODO DEV-41489: Switch all source typing in galleries to use
// content source types to be consistent with the rest of the platform.
export const streamSourceTypeToContentSourceType = (
  sourceType: StreamSourceTypes,
) => {
  switch (sourceType) {
    case StreamSourceTypes.HASHTAG:
      return ContentSourceType.HASHTAG;
    case StreamSourceTypes.USER:
      return ContentSourceType.USER;
  }
};

// Auto Approve modal constants
export const AUTO_FILTERS = {
  configLength: 5,
  containerWidth: 722,
  containerHeight: 491,
};
